import React from 'react';
import { TabBarContainer, Tab, TabText } from './order-list-tab-bar.styles';

export enum OrderTab {
  online = 'online',
  instore = 'instore',
}

export enum OrderSource {
  inStore = 'In-Store',
  online = 'Online',
}

export const TAB_PANEL_IDS = {
  online: 'order-list-panel-online',
  instore: 'order-list-panel-instore',
} as const;

export const TAB_IDS = {
  online: 'order-list-tab-online',
  instore: 'order-list-tab-instore',
} as const;

const TAB_OPTIONS = [OrderTab.online, OrderTab.instore];

type OrderListTabBarProps = {
  selectedTab: OrderTab;
  onTabChange: (tab: OrderTab) => void;
};

export function OrderListTabBar({ selectedTab, onTabChange }: OrderListTabBarProps): JSX.Element {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>): void => {
    const currentIndex = TAB_OPTIONS.indexOf(selectedTab);
    const total = TAB_OPTIONS.length;

    const keyMap: Partial<Record<string, number>> = {
      arrowright: (currentIndex + 1) % total,
      arrowleft: (currentIndex - 1 + total) % total,
    };

    const newIndex = keyMap[e.key.toLowerCase()];
    if (newIndex !== undefined) {
      e.preventDefault();
      const newTab = TAB_OPTIONS[newIndex];
      onTabChange(newTab);
      document.getElementById(TAB_IDS[newTab])?.focus();
    }
  };

  return (
    <TabBarContainer role='tablist' data-testid='order-list-tab-bar'>
      <Tab
        role='tab'
        id={TAB_IDS.online}
        aria-selected={selectedTab === OrderTab.online}
        aria-controls={TAB_PANEL_IDS.online}
        tabIndex={selectedTab === OrderTab.online ? 0 : -1}
        onClick={() => onTabChange(OrderTab.online)}
        onKeyDown={handleKeyDown}
        data-testid='order-list-tab-online'
      >
        <TabText tag='span' size='medium' weight='semi'>
          Online
        </TabText>
      </Tab>
      <Tab
        role='tab'
        id={TAB_IDS.instore}
        aria-selected={selectedTab === OrderTab.instore}
        aria-controls={TAB_PANEL_IDS.instore}
        tabIndex={selectedTab === OrderTab.instore ? 0 : -1}
        onClick={() => onTabChange(OrderTab.instore)}
        onKeyDown={handleKeyDown}
        data-testid='order-list-tab-instore'
      >
        <TabText tag='span' size='medium' weight='semi'>
          In-Store
        </TabText>
      </Tab>
    </TabBarContainer>
  );
}
